<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <TableLoading v-if="processedStatementEmail.publicId === '0'"/>
    <div class="mx-4" v-else>
      <div class="row mb-4">
        <div class="col-md-3">
          <div class="card mini-stats-wid" style="height: 120px">
            <div class="card-body">
              <div class="d-flex">
                <div class="flex-grow-1">
                  <h5 class="text-muted fw-medium mb-4">Customer Name</h5>
                  <h4 class="mb-0">{{processedStatementEmail.customerId.name}}</h4>
                </div>

                <div class="avatar-sm align-self-center mini-stat-icon rounded-circle">
                  <span class="avatar-title bg-primary">
                    <i class="bx bx-home font-size-24"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="card mini-stats-wid" style="height: 120px">
            <div class="card-body">
              <div class="d-flex">
                <div class="flex-grow-1">
                  <h5 class="text-muted fw-medium mb-4">Email Address</h5>
                  <h4 class="mb-0">{{ processedStatementEmail.emailTo }}</h4>
                </div>

                <div class="avatar-sm align-self-center mini-stat-icon rounded-circle">
                  <span class="avatar-title bg-info">
                    <i class="bx bx-envelope font-size-24"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="card mini-stats-wid" style="height: 120px">
            <div class="card-body">
              <div class="d-flex">
                <div class="flex-grow-1">
                  <h5 class="text-muted fw-medium mb-4">Statement ID: {{ processedStatementEmail.statementNumber }}</h5>
<!--                  <b-button variant="warning" size="lg" class="py-1 text-white">-->
<!--                    Print Statement-->
<!--                  </b-button>-->
                </div>

                <div class="avatar-sm align-self-center mini-stat-icon rounded-circle">
                  <span class="avatar-title bg-danger">
                    <i class="bx bxs-file-pdf font-size-24"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="card mini-stats-wid" style="height: 120px">
            <div class="card-body">
              <div class="d-flex">
                <div class="flex-grow-1">
                  <h5 class="text-muted fw-medium mb-4">Date generated</h5>
                  <h4 class="mb-0">{{ formatDate(processedStatementEmail.createdAt) }}</h4>
                </div>
                <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                  <span class="avatar-title bg-success">
                    <i class="bx bx-calendar font-size-24"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <b-tabs pills justified content-class="p-3 text-muted mx-4">
            <b-tab class="border-0" :active="tabIndex === 'order'" @click="tabSelectFn('order')">
              <template v-slot:title>
                <span class="d-none d-sm-inline-block my-2">Orders</span>
              </template>
              <div class="p-4">
                <data-table :columns="customerOrdersColumns" :rows="processedStatementEmail.orders">
                  <template v-slot:actions="slotProps" v-if="checkForPermission(view_single_order_permission)">
                    <b-button variant="info" size="sm" class="py-1 text-white" @click="viewStatementInvoice(slotProps.row.publicId)">
                      View Invoice
                    </b-button>
                  </template>
                </data-table>
              </div>
            </b-tab>
            <b-tab :active="tabIndex === 'attempts'" @click="tabSelectFn('attempts')">
              <template v-slot:title>
                <span class="d-none d-sm-inline-block my-2">Attempts</span>
              </template>
              <div class="p-4 w-75" style="margin: auto">
                <data-table :columns="emailAttemptColumns" :rows="processedStatementEmail.attempts"/>
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config.json";
import Layout from "@/router/layouts/main"
import PageHeader from "@/components/page-header";
import DataTable from "@/components/data-table";
import moment from 'moment'
import {routeItems} from "@/router/endpoints";
import {SINGLE_PROCESSED_EMAIL} from "@/gql/finance";
import TableLoading from "@/components/TableLoading";
import {permissions} from "@/router/permissions";

export default {
  page: {
    title: "Statement Logs",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {TableLoading, DataTable, PageHeader, Layout},
  name: "statement-logs",
  data() {
    return {
      title: "Statement Logs",
      tabIndex: 'order',
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Statement Logs",
          active: true
        }
      ],
      view_single_order_permission: permissions.view_single_order_permission,
      customerOrdersColumns: [
        {
          field: 'invoiceId',
          label: 'Invoice ID'
        },
        {
          field: 'orderedBy',
          label: 'Ordered By'
        },
        {
          field: 'deliveryDate',
          label: 'Delivery Date'
        },
        {
          field: 'grossOrderTotal',
          label: 'Order Total'
        },
        {
          field: 'paymentDueDate',
          label: 'Expected Payment Date'
        },
        {
          field: 'paymentStatus',
          label: 'Payment Status'
        },
        {
          field: 'actions',
          label: 'Actions'
        }
      ],
      emailAttemptColumns: [
        {
          field: 'emailDeliveryDatetime',
          label: 'Emailed At'
        },
        {
          field: 'emailDeliveryStatus',
          label: 'Statement Status'
        }
      ],
      processedStatementEmail: {
        publicId: "0",
        customerId: {
          name: ""
        },
        statementNumber: "",
        createdAt: "",
        emailTo: "",
        emailDeliveryStatus: "",
        orders: [{
          publicId: "",
          invoiceId: "",
          deliveryDate: "",
          grossOrderTotal: "",
          orderedBy: "",
          paymentStatus:{
            name: ""
          },
          paymentDueDate: "",
        }],
        attempts: [{
          emailDeliveryStatus: "",
          emailDeliveryDatetime: ""
        }]
      }
    }
  },
  apollo: {
    processedStatementEmail: {
      query: SINGLE_PROCESSED_EMAIL,
      variables(){
        return {
          id: this.$route.params.id
        }
      }
    }
  },
  methods: {
    viewStatementInvoice(public_id){
      this.$router.push(routeItems.customer_order_invoice_route+'/'+public_id)
    },
    tabSelectFn(index){
      this.$router.replace({...this.$router.currentRoute, query: {tab: index}}).catch(() => {})
    },
    formatDate(date){
      return moment(date).format('LL')
    }
  },
  beforeMount() {
    if (this.$route.query.tab !== undefined){
      this.tabIndex = this.$route.query.tab
    }
  }
}
</script>

<style scoped>

</style>
